import { Component, OnInit, Input, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { NzMessageService } from "ng-zorro-antd/message";
import { Translate } from "@root/util/decorator";
import _ from "lodash";
import { ModalService } from "@root/router/index/modal.service";
interface Image {
  id?: any;
  urls: {
    filename?: string;
    original_url?: string;
    small_url?: string;
    large_url?: string;
  };
}

const IMAGE_UPLOAD_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BaseImageUploadComponent),
  multi: true,
};

@Component({
  selector: "host-base-image-upload",
  templateUrl: "./base-image-upload.component.html",
  styleUrls: ["./base-image-upload.component.scss"],
  providers: [IMAGE_UPLOAD_VALUE_ACCESSOR],
})
export class BaseImageUploadComponent implements OnInit, ControlValueAccessor {

  constructor(
    private messageService: NzMessageService,
    private modalService: ModalService
  ) {}
  @Input() maxSize = 10;
  @Input() showBigImg = false;
  listOfImage: Array<Image> = [];

  @Translate("component.upload.image_format_restrictions") extLimitWarning;
  @Translate("component.upload.image_number_reached_limit") amountLimitWarning;
  @Translate("warning.upload_image_too_large") sizeLimitWarning;
  emitChange = (p: any) => {};

  beforeUpload = (file) => {
    const size = file.size;
    const type = file.type;

    if (["image/jpeg", "image/jpg", "image/png"].indexOf(type) === -1) {
      // this.messageService.info('只允许上传jpg和png格式的图片');
      this.messageService.info(this.extLimitWarning);
      return false;
    }

    if (this.listOfImage.length >= this.maxSize) {
      // this.messageService.info('上传图片数量已达上限');
      this.messageService.info(this.amountLimitWarning);
      return false;
    }

    if (size > 10 * 1024 * 1024) {
      // this.messageService.info('图片过大，请选择小于10M的图片上传！');
      this.messageService.info(this.sizeLimitWarning);
      return false;
    }

    return true;
  };

  ngOnInit() {}

  writeValue(images: Array<Image>) {
    this.listOfImage = images;
  }

  registerOnChange(fn: any): void {
    this.emitChange = fn;
  }
  registerOnTouched(fn: any): void {}

  onDeleteImage(img) {
    _.remove(this.listOfImage, (image) => image === img);

    this.emitChange(this.listOfImage);
  }
  handleChange(result) {
    const file = result.file;
    if (file.status === "done") {
      const urls = _.get(file, "response.data.file");

      const image = { urls };
      this.listOfImage = _.concat(this.listOfImage, image);
      this.emitChange(this.listOfImage);
    }
  }

  showLargeImg(url) {
    this.modalService.displayImageMagnifier(url);
  }
}
